export default __webpack_public_path__ + "static/media/generalaa.11b5c469.png";